export default __webpack_public_path__ + "static/media/icon-video-tutorial.a30f1c02.svg";